<template>
  <div>
    <div v-if="modName == 'home'"  v-model="pName">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>

        <div class="layout-copy" style="position: absolute;left: 50%;bottom: 10px;" >
          2011-2016 &copy; iSenLoRa
        </div>
    </div>

    <div  v-else>
        <div class="layout-menu-left" :class="{'layout-mobile-menu' : leftHiden}">
        <!-- <app-sidebar :leftLists='menuLeftLists'> </app-sidebar> -->
        <!-- 根据数组显示左侧导航 start -->
          <Menu theme="dark" style="width: 199px !important;">
              <Menu-item  @click.native="goto('/'+item.url)" @click="clickLeft" :name="index+'-'+index" v-for="(item,index) in leftLists" :class="[currLeft[index] ? 'ivu-menu-item-active' : 'old-menu-bgc' ]" >
                <Icon :type="item.icon">
                </Icon>
                {{item.name}}
                <!-- {{item.url}} -->

              </Menu-item >
          </Menu>
          <!-- 根据数组显示左侧导航 start -->
          <!-- <Menu theme="dark" style="width: 199px !important;">
              <div v-for="(item,index) in leftLists">
              
                <div v-if="!item.childMenu">
                      <Menu-item  @click.native="goto('/'+item.url)"  :name="index+'-'+index">
                        <Icon :type="item.icon">
                        </Icon>
                        {{item.name}}  
                      </Menu-item >
                </div>
                <div v-else>
                  <Submenu :name="index">
                  
                    <template slot="title" >
                      <Icon :type="item.icon"></Icon>
                      {{item.name}}
                    </template>
                     <Menu-item @click.native="goto('/'+list.url)" style="color:#fff;" v-for="(list,index1) in item.lists" :name="index+'-'+index1" >{{list.name}} </Menu-item>
                    </Submenu>
                </div>

              </div>
              </Menu> -->

          <!-- 根据数组显示左侧导航 end -->
          <!-- 根据数组显示左侧导航 end -->
          

        </div>

        <div class="layout-content-right " :class="{'layout-mobile-content' : leftHiden}">

       
          <keep-alive>
            <router-view></router-view>
          </keep-alive>

          <div class="layout-copy" >
            2011-2016 &copy; iSenLoRa
          </div>

        </div>
    </div>
        
  </div>
</template>
<style>
/*内容左右块布局*/
.layout-menu-left {
  background: rgba(33,33,33,0.8);
  width: 200px;
  float: left;
}

.layout-content-right {
  margin-left: 200px;
  position: relative;
  min-height: calc(100vh - 90px);
  min-height: -webkit-calc(100vh - 90px);
  min-width: -moz-calc(100vh - 90px);
}

/*隐藏左侧边栏样式*/
.layout-mobile-menu {
display: none;
}
.layout-mobile-content {
margin-left: 0px;
}
.old-menu-bgc{
  color:rgba(255,255,255,.7) !important;
  background:none !important;
  border-bottom: none !important;
  border-right: none !important;
}

</style>
<script>

  export default{
    data(){
      return {
        routePath:'',
        pathName:'',
        moduleName:'',
        // ,
      }
    },
    props:['leftLists','pName','modName','goto','leftHiden','currLeft'],
    mounted:function () {
      console.log(this.currLeft)
    },
    methods: {
      clickLeft:function(url){
        location.reload() ;
      },
    },
    components: {}
  }
</script>



// WEBPACK FOOTER //
// appContent.vue?4b508ebc